import {
	Integration,
	IntegrationFeatureWebhook,
	IntegrationProviderId,
	IntegrationStatus,
	SettingsConfig,
	SettingsConfigType,
} from "../../../../index";

const githubIntegration = new Integration({
	id: "github",
	name: "GitHub integration",
	description:
		"Connect GitHub from an add-on setup page, choose all or specific repositories in GitHub, then map any authorized repository in Version2.",
	providerId: IntegrationProviderId.GITHUB,
	status: IntegrationStatus.ACTIVE,
	docsUrl: "",
	features: [new IntegrationFeatureWebhook()],
	settingsConfig: [
		new SettingsConfig({
			id: "display_name",
			label: "Integration name",
			description:
				"The name of the integration that will be displayed in the integrations list",
			type: SettingsConfigType.STRING,
			required: true,
			editable: true,
			encrypted: false,
		}),
	],
});

export default githubIntegration;
